import {
  IconArchive,
  IconCopySimple,
  Menu,
  MenuButton,
  MenuItem,
  useMenuState,
} from '@vtex/admin-ui'
import { useNavigation } from '@vtex/raccoon-next'
import { useRef } from 'react'
import { useIntl } from 'react-intl'
import { useFormStateContext, usePromotionState } from 'ui'
import {
  DuplicateModalRef,
  DuplicateModalWithFlags,
} from '../Duplicate/DuplicateModalWithFlags'

export function HeaderActionMenu() {
  const state = useMenuState()
  const { form } = useFormStateContext()
  const { navigate } = useNavigation()
  const { formatMessage } = useIntl()
  const modalRef = useRef<DuplicateModalRef>(null)

  const item = form.getValues()

  const { archive } = usePromotionState()

  return (
    <>
      <MenuButton
        state={state}
        labelHidden
        size="large"
        variant="neutralTertiary"
        aria-label={formatMessage({ id: 'admin/promotions.commons.actions' })}
      />

      <Menu state={state}>
        <MenuItem
          icon={<IconCopySimple />}
          label={formatMessage({
            id: 'admin/promotions.list.actions.duplicate',
          })}
          onClick={() => modalRef.current?.onDuplicate(item)}
        />
        <MenuItem
          icon={<IconArchive />}
          onClick={() =>
            archive(item.id).then(() => {
              navigate('/')
            })
          }
          label={formatMessage({ id: 'admin/promotions.list.actions.archive' })}
        />
      </Menu>
      <DuplicateModalWithFlags ref={modalRef} eventSource="action-menu" />
    </>
  )
}
